/*
 * @Author: your name
 * @Date: 2021-03-11 16:52:28
 * @LastEditTime: 2021-03-13 16:05:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\api\config.js
 */

import axios from 'axios'

const service = axios.create({
  baseURL: 'https://admin.mooklook.com', // api 的 base_url
  withCredentials: false,
  timeout: 10000, // request timeout
  // 配置请求头
  headers: {
    'Content-Type': 'application/json'
  }
})

       // 添加axios请求拦截器, 该方法在请求之前触发
       service.interceptors.request.use(config => {

        if (config.method === 'post') {
            //进行data参数序列化
            // config.data参数
            if (config.data) {
                let dataString = '';

                for (let key in config.data) {
                    dataString += key + '=' + config.data[key] + '&';
                }
                config.data = dataString.slice(0, -1);
            }
        }

        return config;

    }, err => {
        return Promise.reject(err);
    })
    

export default service
